<div class="right-panel h-100">
  <div class="actionBar">
    <div>
      <input class="searchBar" type="text" placeholder="Search by name or action" [(ngModel)]="filterText" />
    </div>
    <div ngDeafaultControl *ngIf="logNumberEntries.length > 0" style="margin-right: 4px; color: var(--s-primary-color); font-size: 12px;">
      From {{ startRange }} To
    </div>
    <select name="showEntries" *ngIf="logNumberEntries.length > 0" class="searchFilter" [(ngModel)]="entries" ngDefaultControl (ngModelChange)='loadLogsDataForRange(entries)'>
      <option *ngFor="let entries of logNumberEntries; let i = index" [value]="entries">
        {{ entries }}
      </option>
    </select>
    <select name="actionType"
            class="actionBarFilter"
            [(ngModel)]="actionFilterValue"
            (ngModelChange)="applyFilter()">
      <option value="all" title="All Actions">All Actions</option>
      <option *ngFor="let actionType of allActionTypes"
              title="{{ actionType }}"
              value="{{ actionType }}">
        {{ actionType }}
      </option>
    </select>
    <select name="actionLevel"
            class="actionBarFilter"
            [(ngModel)]="actionLevelFilterValue"
            (ngModelChange)="applyFilter()">
      <option value="10" title="All Types">All Types</option>
      <option *ngFor="let actionLevel of allActionLevels"
              title="{{ actionLevel | notificationCheck }}"
              value="{{ actionLevel }}">
        {{ actionLevel | notificationCheck }}
      </option>
    </select>
    <select name="initiator"
            class="actionBarFilter"
            [(ngModel)]="initiatorFilterValue"
            (ngModelChange)="applyFilter()">
      <option value="all" title="All Initiators">All Initiators</option>
      <option *ngFor="let initiator of allInitiators"
              title="{{ initiator }}"
              value="{{ initiator }}">
        {{ initiator }}
      </option>
    </select>
    <button type="button"
            class="default-btn"
            title="Reset applied filters"
            (click)="resetFilter()"
            #btnResetFilter>
      <span class="bi bi-x-lg text-danger"></span>
      Reset Filters
    </button>

    <div class="newDir" ngbDropdown container="body">
      <button type="button" class="default-btn bi bi-download" title="Download Action Logs" ngbDropdownToggle> Download </button>
      <div ngbDropdownMenu>
        <button ngbDropdownItem
                title="Download Currently Fetched Logs"
                (click)="downloadActionLogs(false)">
          <i class="bi bi-file-earmark-arrow-down"></i>
          Download Logs
        </button>
        <button ngbDropdownItem
                title="Download All Action Logs"
                (click)="downloadActionLogs(true)">
          <i class="bi bi-file-earmark-arrow-down-fill"></i>
          Download All Logs
        </button>
      </div>
    </div>

    <button type="button"
            *ngIf="showDelete"
            class="default-btn"
            title="Delete Selected Action Logs"
            (click)="deleteActionLog()">
      <span class="bi bi-x-lg text-danger"></span>
      Delete Log
    </button>
  </div>
  <div class="logTable" style="white-space: nowrap;">
    <div [ngStyle]="{ 'flex-grow': dataAvailable ? '1' : '' }">
      <table class="table table-striped">
        <thead>
          <tr class="table-list-head">
            <th resizable>
              <input (change)="onSelectAllCheckBox($event)"
                     [checked]="selectAll"
                     type="checkbox"
                     title="Checking this will select all the action logs available" />
            </th>
            <th resizable>#</th>
            <th resizable>
              Action
              <span [ngClass]="
                sortAction == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                    class="bi" (click)="sortByAction()">
              </span>
            </th>
            <th resizable>
              Type
              <span [ngClass]="
                sortType == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                    class="bi" (click)="sortByType()">
              </span>
            </th>
            <th resizable>
              Initiator
              <span [ngClass]="
                sortInitiator == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                    class="bi" (click)="sortByInitiator()">
              </span>
            </th>
            <th resizable (click)="sortByTime()">
              Time
              <span *ngIf="dataAvailable"
                    [ngClass]="
                  sortDate == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                "
                    class="bi"></span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="table-list-row" *ngFor="
              let action of actionLogs | logFilter: filterText
                | paginate: { itemsPerPage: 14, currentPage: p };
              let i = index
            ">
            <td>
              <input type="checkbox"
                     name=""
                     id=""
                     [checked]="selectedActionLogs.includes(action.actionLogId)"
                     (change)="onCheckboxSelect($event, action.actionLogId)" />
            </td>
            <td scope="row">{{ (startRange - 1) + action.actionIndex }}</td>
            <td>{{ action.action }}</td>
            <td>{{ action.actionLevel | notificationCheck }}</td>
            <td>{{ action.initiator }}</td>
            <td>{{ action.actionTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="errorMsg" *ngIf="!dataAvailable">No Action logs available.</p>
    <pagination-controls *ngIf="dataAvailable"
                         class="my-pagination"
                         (pageChange)="p = $event"></pagination-controls>
  </div>
  <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default"
               zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"><p class="pleaseWait">Please wait ...</p></ngx-spinner>
</div>
